<section>
  <app-auth-template
    [title]="title()"
    [description]="description()"
  >
    @if (showForm) {
      <form>
        <app-input
          type="text"
          [control]="formControl"
          [label]="'Email'"
          errorMsg="Eingabe erforderlich"
        />

        <app-auth-button
          [buttonText]="'Passwort zurücksetzten'"
          [disabled]="formControl.invalid"
          [isLoading]="requestState() === RequestStateEnum.PENDING"
          [showHint]="true"
          hintText="Zurück zum"
          linkText="Login?"
          (clicked)="resetPassword()"
        />
      </form>
    } @else {
      <app-auth-button
        [showHint]="true"
        buttonText="Zum Login"
        (clicked)="goToLogin()"
      />
    }
  </app-auth-template>
</section>
